/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
      this.reservationStorageKey = 'bloomr_saudi_cart_reservation_deadline';
    }

    connectedCallback() {
      let amountText = this.querySelector('.free-shipping--text span');
      let total = parseInt(this.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');

      if (total < minimum) {
        percentage = total / minimum;

        if (amountText) {
          let remaining = minimum - total;
          let format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amountText.innerHTML = formatMoney(remaining, format);
        }

        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'block';
          this.fullText.style.display = 'none';
        }
      } else {
        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'none';
          this.fullText.style.display = 'block';
        }
      }

      this.style.setProperty('--percentage', percentage);

      // The reservation message belongs to this drawer instance. Keeping the
      // query scoped prevents the static cart progress bar from starting a
      // second countdown for the drawer.
      const drawer = this.closest('.cart-drawer');
      this.reservedContainer = drawer?.querySelector('.cart-drawer--reserved-message');
      if (this.reservedContainer) {
        if (total >= minimum) {
          this.reservedContainer.hidden = false;
          this.startCountdown(
            this.reservedContainer.querySelector('.free-shipping--reserved-timer'),
          );
        } else {
          this.reservedContainer.hidden = true;
          this.clearCountdown(true);
        }
      }
    }

    startCountdown(timerElement) {
      if (!timerElement) return;

      const storageKey = this.reservationStorageKey;
      const duration = 84 * 60 * 1000;
      let deadline = Number(window.localStorage?.getItem(storageKey));

      if (!Number.isFinite(deadline) || deadline <= Date.now()) {
        deadline = Date.now() + duration;
        window.localStorage?.setItem(storageKey, String(deadline));
      }

      this.clearCountdown(false);

      const updateTimer = () => {
        const remaining = deadline - Date.now();
        if (remaining <= 0) {
          timerElement.textContent = '00:00:00';
          if (this.reservedContainer) this.reservedContainer.hidden = true;
          this.clearCountdown(true);
          return;
        }

        const hours = Math.floor(remaining / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        timerElement.textContent = [hours, minutes, seconds]
          .map((part) => String(part).padStart(2, '0'))
          .join(':');
      };

      updateTimer();
      this.timerInterval = window.setInterval(updateTimer, 1000);
    }

    clearCountdown(removeDeadline = false) {
      if (this.timerInterval) {
        window.clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
      if (removeDeadline && this.reservationStorageKey) {
        window.localStorage?.removeItem(this.reservationStorageKey);
      }
    }

    disconnectedCallback() {
      this.clearCountdown(false);
    }
  }

  customElements.define('free-shipping', FreeShipping);
}
